import type { TutorPresentation } from "./tutorProfileApi.js";

/** Display labels only, derived within each server-scoped tutor's own teaching context. */
export function homeTutorSubjects(tutor: TutorPresentation): string[] {
  if (tutor.instruments.length) return [...new Set(tutor.instruments)];
  // Imported assignments may have service names but no instrument field.
  // Recognise instrument words for display; retain unfamiliar service names.
  const instruments = [
    [/\bdrums?\b/i, "Drums"], [/\bpiano\b/i, "Piano"],
    [/\bguitar\b/i, "Guitar"], [/\bbass\b/i, "Bass"],
    [/\b(?:singing|vocals?|voice)\b/i, "Singing"],
    [/\bviolin\b/i, "Violin"], [/\bukulele\b/i, "Ukulele"],
    [/\bmandolin\b/i, "Mandolin"],
    [/\bsaxophone\b/i, "Saxophone"],
  ] as const;
  return [...new Set(tutor.services.flatMap((service) => {
    const names = instruments.filter(([pattern]) => pattern.test(service)).map(([, name]) => name);
    return names.length ? names : [service];
  }))];
}

export function homeTutorSummary(tutors: readonly TutorPresentation[]): string {
  return tutors.flatMap((tutor) => {
    const subjects = homeTutorSubjects(tutor);
    return (subjects.length ? subjects : ["Lessons"]).map((subject) => `${subject} with ${tutor.displayName}`);
  }).sort((a, b) => a.localeCompare(b)).join(" · ");
}
